import type { ApiBetsItem, ApiBetsTotals } from '@/types/bets';
import { defineStore } from 'pinia';
import { fetchBets, refundBrokenBet, repayBrokenBet, reSettleBet, rollBackBet } from '@/api/admin-be';
import { catchError } from '@/helpers/toast';
import { localDateToUTC } from '@/utils/date';

export enum FilterBetSlipStatus {
  Open = 'open',
  Rejected = 'rejected',
  Won = 'won',
  Lost = 'lost',
  Voided = 'voided',
}

type BetsStoreState = {
  offset: number;
  count: number;
  size: number;
  records: ApiBetsItem[] | null;
  totals: ApiBetsTotals | null | undefined;
  loading: boolean;
  fromDate: Date | null;
  toDate: Date | null;
  skipResolved: string;
  status: null | FilterBetSlipStatus;
  userIds: null | number[];
  currencies: null | string[];
};

export const useBetsStore = defineStore('bets', {
  state: () =>
    ({
      offset: 0,
      count: 0,
      size: 10,
      records: null,
      totals: null,
      loading: false,
      fromDate: null,
      toDate: null,
      skipResolved: 'false',

      status: null as null | FilterBetSlipStatus,
      userIds: null as null | number[],
      currencies: null as null | string[],
    }) as BetsStoreState,
  actions: {
    fetchRecords(filters: any) {
      this.loading = true;
      const requestFilters = {
        ...filters,
        offset: this.offset,
        count: this.size,
        fromDate: localDateToUTC(this.fromDate, 0)?.toISOString() || undefined,
        toDate: localDateToUTC(this.toDate, 0)?.toISOString() || undefined,
      };

      fetchBets(requestFilters)
        .then((response) => {
          this.records = response.bets;
          this.count = response.count;
          this.totals = response.totals;
        })
        .catch((error) => catchError('Ошибка загрузки ставок', error))
        .finally(() => {
          this.loading = false;
        });
    },

    async reSettleBet(guid: string | number) {
      return reSettleBet(guid)
        .then(() => catchError('Повторно отправлено в BetGenius', { message: guid }, 'warn'))
        .catch((error) => catchError('Ошибка переотправки ставки', error));
    },

    async refundBroken(guid: string) {
      return refundBrokenBet(guid).catch((error) => catchError('Ошибка возврата', error));
    },

    async repayBroken(guid: string) {
      return repayBrokenBet(guid)
        .then(() => catchError('Повторная выплата отправлена в кошелек', { message: guid }, 'warn'))
        .catch((error) => catchError('Ошибка повторного начисления', error));
    },
    async rollBack(guid: string) {
      return rollBackBet(guid)
        .then(() => catchError('Отмена расчета ставки', { message: guid }, 'warn'))
        .catch((error) => catchError('Ошибка отмены расчета ставки', error));
    },
  },
});
